import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import * as z from "zod";

import { useState } from "react";
import { handleApiError } from "@/utils/errors";
import { catchError } from "@/lib/errors";
import { toast } from "sonner";
import DotPattern from "@/components/dot-pattern";
import ThemeForm from "@/features/themes/components/form/theme-form";
import { themeFormSchema } from "@/features/themes/components/form/schemas";
import { themesRepo } from "@/lib/repositories";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import { useTranslation } from "react-i18next";
import { queryClient } from "@/lib/query-client";
import { getRandomHexColor } from "@/lib/utils";

const ThemesCreatePage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const form = useForm<z.infer<typeof themeFormSchema>>({
    resolver: zodResolver(themeFormSchema),
    defaultValues: {
      name: "",
      description: "",
      color: getRandomHexColor(),
      status: "active",
    },
  });

  async function onSubmit(data: z.infer<typeof themeFormSchema>) {
    setIsLoading(true);
    const [error, themeData] = await catchError(themesRepo.create(data));
    if (error) toast.error(handleApiError(error).message);
    if (themeData) {
      await queryClient.invalidateQueries({ queryKey: ["themes"] });
      toast.success(t("messages.theme_create_success"));
      form.reset();
      navigate(ROUTES.THEMES);
    }
    setIsLoading(false);
  }

  return (
    <div className="relative h-full flex flex-col items-center gap-y-3 p-3 py-4 sm:py-10 sm:p-6">
      <DotPattern />
      <ThemeForm form={form} onSubmit={onSubmit} isLoading={isLoading} />
    </div>
  );
};

export default ThemesCreatePage;
